import React from 'react';
import { useIntl } from 'react-intl';
import { DisplayName } from '@99designs/frontend-components/components/DisplayName';
import { Ribbon } from '@99designs/frontend-components/components/Ribbon';
import Box from '../../../../../shared/components/Box';
import { DesignerCard } from '../../../../../shared/components/Card';
import DesignCard from '../../../../../shared/components/DesignCard';
import TwoColumnContainer from '../../../../../shared/components/TwoColumnContainer';
import localizedLowercase from '../../../../../shared/lib/localizedLowercase';
import { AvatarSkeleton } from '../../../../../shared/spa/core-components/Avatar';
import { WinnersFAQs } from '../../FAQs';
import ClientReview from '../ClientReview';

export interface Props {
    categoryTitle: string;
}

function OpenContestSection({ categoryTitle }: Props) {
    const { locale } = useIntl();
    return (
        <div className="row" data-testid="open-contest-section">
            <div className="column small-12 medium-8 medium-offset-2 normal-12 large-12">
                <div className="row">
                    <div
                        className="column small-12 medium-12 normal-5 normal-offset-1 large-4 large-offset-2"
                        style={{ textAlign: 'center' }}
                    >
                        <Box paddingRight={['none', 'none', 'space10', 'space10']}>
                            <DesignerCard
                                variations={['inline']}
                                meta={
                                    <TwoColumnContainer
                                        variations={['inline', 'text-left-aligned', 'centered']}
                                        colOne={<AvatarSkeleton size="medium" />}
                                        colTwo={
                                            <Box paddingLeft="space7">
                                                <DisplayName
                                                    user={{
                                                        name: __('Talented designer coming…'),
                                                    }}
                                                    isLinked={false}
                                                />
                                            </Box>
                                        }
                                    />
                                }
                                gallery={
                                    <DesignCard
                                        ribbon={
                                            <Ribbon variations={['large']}>
                                                {__('Future winner')}
                                            </Ribbon>
                                        }
                                    />
                                }
                            />
                        </Box>
                    </div>
                    <div className="column small-12 medium-12 normal-5 large-4">
                        <ClientReview />
                        <WinnersFAQs
                            categoryDeliverable={localizedLowercase(locale, categoryTitle)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OpenContestSection;
